/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_After_TrialInputs */

const en_premium_after_trial = /** @type {(inputs: Premium_After_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After free trial, it's:`)
};

const es_premium_after_trial = /** @type {(inputs: Premium_After_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después de la prueba gratuita, es:`)
};

/**
* | output |
* | --- |
* | "After free trial, it's:" |
*
* @param {Premium_After_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_after_trial = /** @type {((inputs?: Premium_After_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_After_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_after_trial(inputs)
	return en_premium_after_trial(inputs)
});